import React, { Component } from "react";
import styled from "styled-components";

import {
  institutionsName,
  institutionsType,
} from "@/database/institutions.json";

import Footer from "@/assets/homePage/footer.png";

const Div = styled.div`
  width: 100%;
  height: 30.4rem;
  background-image: ${(props) => `url(${props.footer})`};
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;

  .footer-container {
    width: 120rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .footNav-container {
      height: 10rem;
      width: 120rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .footNav-title {
        font-size: 1.8rem;
        color: #ffffff;
      }

      ul.footNav-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        li {
          position: relative;
          color: rgba(255, 255, 255, 0.7);
          font-size: 1.6rem;
          cursor: pointer;
          &:hover {
            color: #ffffff;
            &::after {
              position: absolute;
              content: "";
              width: 0.4rem;
              height: 0.4rem;
              border-radius: 50%;
              background-color: #ffffff;
              bottom: -0.9rem;
              left: 3rem;
            }
          }
        }
      }
    }

    /* .QRCodes-container {
      width: 20rem;
    } */
  }
  .beianhao {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    margin-bottom: 60px;
  }
`;

class PageFooter extends Component {
  state = {
    footNavDatas: [
      "网站首页",
      "学习报名",
      "在线练习",
      "考题练习",
      "模拟考试",
      "培训学习",
    ],
  };

  render() {
    return (
      <Div footer={Footer}>
        <div className="footer-container">
          <div className="footNav-container">
            <div className="footNav-title">
              {institutionsName + institutionsType}
            </div>
            <ul className="footNav-container">
              {this.state.footNavDatas.map((data, index) => (
                <li key={`nav-${index}`}>{data}</li>
              ))}
            </ul>
          </div>
          {/* <div className="QRCodes-container"></div> */}
        </div>
        <div className="beianhao">
          备案号:鲁ICP备14014132号-2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本系统由
          <a
            href="https://www.shejiyuan.com/"
            style={{ textDecoration: "none", color: "blue" }}
          >
            设计院网
          </a>{" "}
          提供技术支持
        </div>
      </Div>
    );
  }
}

export default PageFooter;
